import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import Spinner from "../../Components/Spinner/Spinner";
import { AuthContext } from "../../Contexts/AuthProvider/AuthProvider";

import useSeller from "../../hooks/useSeller";

const SellerRoute = ({ children }) => {
  const location = useLocation();
  const { user, loading } = useContext(AuthContext);
  const [isSeller, isSellerLoading] = useSeller(user?.email);
  if (loading || isSellerLoading) {
    return <Spinner></Spinner>;
  }
  if (user && isSeller) {
    return children;
  }
  return (
    <Navigate to="/errorpage" state={{ from: location }} replace></Navigate>
  );
};

export default SellerRoute;
